import {cloneDeep, isEmpty, uniqWith, isEqual, sortBy} from "lodash-es";
import MenuOptionsService from "app/services/menuOptions/menuOptions.service";
import {BookingStatusNames, BookingStatusTypes, StatusUnconfirmed} from 'app/bookingStatusTypes';
import {AdminServiceLog, BookingMethods, BookingType, FunctionTrackerInfo, PaymentTypes} from "app/app.types";
import {ManualJoinType} from "shared-components/table-seater/types";
import TableSelectionService from "external-services/table-selection-service/index";
import {first} from "rxjs/operators";
import {StatusService, StatusServiceInstance} from "external-services/status-service";
import {UrlGeneratorService} from "external-services/url-generator-service/UrlGenerator.service";
import {EditBookingTabs, TabSelectionService} from 'external-services/tab-selection-service/TabSelection.service';
import ObjectCopyService from "external-services/object-copy-service/index";
import ReportingService from "app/services/reporting/reporting.service";
import {IntlService} from "external-services/intl-service/index";
import TableJoinService, {JOIN_PREFIX} from "app/services/tableJoin/tableJoin.service";
import MenuOptionReducerService from "app/fakeReducer/menuOption.reducer";
import ViewActionsService from 'app/actions/view.actions';
import PaymentService from "external-services/diary-payment-service";
import TelemetryService from "app/services/telemetry/telemetry.service";
import { BookingAvailabilityService } from "app/services/LegacyBookingAvailabilityService";

import {default as SharedBookingService} from 'external-services/booking-service/index';
import RecurringBookingService from 'shared-services/recurring-booking-service/index';
import NetworkConnectionService from 'external-services/network-connection-service/index';
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import TrackingService from 'app/services/tracking/tracking.service';
import TagsService from "external-services/tags-service";
import AdminService from "external-services/diary-admin-service/admin.service";
import ManagerService from "external-services/manager-service/manager.service";
import PhoneNumberService from "external-services/phone-number-service/index";
import CustomerValidationService from "app/services/customerValidation/customerValidation.service";
import { CustomerGeneratorService } from "external-services/customer-generator-service";
import UtilsService from "internal-services/utils/utils.service";
import BookingOptionsManagerService from "app/services/bookingOptionsManager/bookingOptionsManager.service";
import BookingIntervalService from "app/services/bookingInterval/bookingInterval.service";
import MaxOccupancyService, {OVER_MAX} from "app/services/maxOccupancy/maxOccupancy.service";
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import StaffService from "external-services/staff-service/staff.service";
import BookingLookupService from "external-services/booking-lookup-service/index";
import BookingUpdateService from "external-services/booking-update-service/index";
import BookingsUtilsService from 'app/services/bookingsUtils/bookingsUtils.service';
import ScheduleLookupService from 'external-services/schedule-lookup-service/scheduleLookup.service';
import BookingsLockService from 'external-services/booking-lock-service/index';
import SmsService from 'external-services/sms-service';
import BookingChangeService from "external-services/booking-change-service/bookingChange.service";
import LayoutsService from 'external-services/layouts-service/layouts.service';
import DateUtilsService from 'external-services/date-utils-service';
import SimpleDialogActions from "app/actions/simpleDialog.actions";
import ServicesLookupService from 'shared-services/services-lookup-service';

import BookingValidationService from "shared-services/booking-validation-service/index";
import CompareObjectsService from 'external-services/compare-objects-service/CompareObjects';
import SectionsService from "external-services/sections-service/index";
import {
  ICustomer,
  SECTION_ANY_ID,
  BookingCancelledReason,
  servicePaymentType,
  paymentProviderTypeUppercase,
  bookingStatusType
} from "shared-types/index";
import CustomerLookupService from 'external-services/customer-lookup-service';
import CustomerUpdateService from "external-services/customer-update-service/customerUpdate.service";
import PaymentValidationService from 'app/services/paymentValidation/paymentValidation.service';
import CustomerService from 'app/services/customer/customer.service';
// Just for getFlatExtras function
import MenuOptionsServiceShared from "external-services/menu-options-service/index";
import {WHOLE_NUMBER_REGEX} from "appRoot/app.constants";
import store from "appRoot/Store";
import StatusConfigService from "external-services/status-config-service";
import { MessageService } from 'external-services/message-service/index';
import BookingNormaliseService from 'external-services/booking-normalise-service/bookingNormalise.service';

const NS = 'EditBooking'; // jshint ignore:line

/**
 * element contains $element object, which is passed from the main.controller.js
 */
export default function EditBooking(
  $q, $log, $rootScope, $scope, $mdDialog, $window, $timeout, $filter, $interpolate, $document,
  booking,
  bookingsCalulationsService,
  AppEventService,
  unregister, isTouchDevice, appValues,
  hardCodedTags, element,
  AuthService
) {
  "ngInject";
  var listeners = [];
  var t0, t1;
  t0 = performance.now();
  var vm = this;
  var bookingsByTable;
  var tableLookUps;
  var seatNowTime;
  var orgBooking = BookingsUtilsService.getEditBookingOriginal();
  var orgCustomer;
  var settings;
  let paymentTypeSubs; // type Subscription (rxjs)

  // states
  vm.LOADING = 1;
  vm.LOADING_UI_1 = 7;
  vm.ENTER = 0;
  vm.SUCCESS = 2;
  vm.ERROR = 3;
  vm.ERROR_LOADING = 4;
  vm.ERROR_CONFLICT = 6;
  vm.SHOW_PAYMENT_URL = 5;

  vm.STANDBY_LIST = BookingType.StandbyList;
  vm.BOOKING = BookingType.Booking;
  vm.WL = BookingType.WaitList;

  vm.allBookingOptions = [];

  vm.BookingStatusNames = BookingStatusNames;
  vm.BookingType = BookingType;
  vm.ManualJoinType = ManualJoinType;

  // properties
  vm.paymentTypes = PaymentTypes;
  vm.account = AdminService.getAccount();
  vm.venue = AdminService.getVenue();
  vm.phoneWithoutPrefix = '';
  vm.phoneInitial = '';
  vm.setPhoneWithoutPrefix = setPhoneWithoutPrefix;
  vm.theme = AdminService.getThemeValues();
  vm.setUp = false;
  vm.extraInfoLoaded = false;
  vm.customer = false;
  vm.customers = [];
  vm.booking = ObjectCopyService.angularSafeCopy(booking);
  MenuOptionReducerService.setBooking(ObjectCopyService.angularSafeCopy(vm.booking));
  if (!vm.booking.status) {
    StatusService.populateMissingStatusInBooking(vm.booking);
  }
  const timezoneId = AdminService.getVenueTimezoneId();
  vm.localBookedAtTime = DateUtilsService.toVenueTime(booking.bookedAt, timezoneId);
  vm.localLastModifiedDate = DateUtilsService.toVenueTime(booking.lastModifiedDate, timezoneId);
  vm.lockedOrginally = ObjectCopyService.angularSafeCopy(booking.locked);
  vm.statusName = vm.booking.status.name;
  vm.isDisabled = false;
  const {statusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
  vm.statusOptions = statusOptions;
  vm.selectdTableIds = [];
  vm.sblSelectedTableIds = [];
  vm.customerBookings = [];
  vm.filteredCustomerBookings = [];
  vm.venueVisitHistory = [];
  vm.onWaitList = false;
  vm.minBookingDuration = 30;

  vm.EditBookingTabs = EditBookingTabs;
  vm.selectedTab = TabSelectionService.getEditBookingVisibleTabIndex(EditBookingTabs.summary);

  vm.manualJoinTables = true;
  vm.sendConfirmation = false;
  vm.isManager = ManagerService.isManager;
  vm.customTime = false;
  vm.isOffline = false;
  vm.staffName = null;
  vm.appVersion = appValues.VERSION_SHORT;
  vm.emailValidationLink = (...args) => CustomerValidationService.emailValidationLink(...args);
  vm.operationSuccess = false;
  vm.hasPriceChanges = false;
  vm.isPaymentDisabled = false;
  vm.customerLoaded = false;
  vm.hasTableLoaded = false;
  vm.isSaveEnabled = true;
  vm.isPaymentLinkPopupConfirmed = false;
  // removed vm.hasSectionMaxOccupancyLoaded as it is not used
  vm.showFunctionTrackerAlertDialog = false;
  vm.closeFunctionTrackerAlertDialog = closeFunctionTrackerAlertDialog;
  vm.functionTrackerAlertHeader = "Information";
  vm.functionTrackerAlertMessage = "Any changes made to this event in NBI will not update Function Tracker – Please use the Function Tracker link located in the links tab to make changes";
  vm.avgSpendAmount = null;

  vm.CUSTOMER_BOOKING_LIMIT_DEFAULT = 10;
  vm.customerBookingsLimit = vm.CUSTOMER_BOOKING_LIMIT_DEFAULT;

  if (!isEmpty(vm.venue.titleSubscription)) {
    vm.titleSubscription = MessageService.getMessage(
      vm.venue.titleSubscription,
      { venueName: vm.venue.name },
      null
    )
  }

  vm.isUsingWidgetV2 = vm.theme.widgetVersion === 2;
  vm.widgetUrl = vm.isUsingWidgetV2 ? $window.config.widgetV2Url : $window.config.widgetUrl;

  vm.booking.selectedOptions = !isEmpty(vm.booking.selectedOptions) ? vm.booking.selectedOptions.map((option) => {
    return MenuOptionsService.getSelectedOptionsWithUpsell(option, vm.booking.selectedOptions);
  }) : []; // add isUpsellItem value to the selectedMenuOptions
  vm.selectedBookingOptions = MenuOptionsService.filterBookingOptionsNonUpsell(vm.booking.selectedOptions);
  vm.selectedUpsellOptions = MenuOptionsService.filterBookingOptionsUpsell(vm.booking.selectedOptions);

  vm.menuBookingOptions = [];
  vm.menuUpsellOptions = [];
  vm.WHOLE_NUMBER_REGEX = WHOLE_NUMBER_REGEX;


  vm.triggerBookedByValidation = 1;

  let bookingOptionsValid = true;
  let upsellOptionsValid = true;
  let isPaxChanged = false;
  let staffEditRequiredFromSettings = false;
  let staffEditOptions = null;

  TabSelectionService.updateEditBookingTabEnabled(EditBookingTabs.covidGuestList, vm.venue.isCovidGuestMode);

  // time
  if (angular.isString(vm.booking.time)) {
    vm.booking.time = DateUtilsService.dateTimeStrToDate(vm.booking.time);
  }
  vm.bookingDate = ObjectCopyService.angularSafeCopy(vm.booking.time);
  vm.bookForDate = ObjectCopyService.angularSafeCopy(vm.bookingDate);
  if (DateUtilsService.isTimeSmallerThanDayEnd(vm.bookForDate)) {
    // TODO make the 4am check a gobal setting
    vm.bookForDate.setDate(vm.bookForDate.getDate() - 1);
  }
  vm.orgBookingTime = ObjectCopyService.angularSafeCopy(vm.booking.time);
  vm.isDateToday = DateUtilsService.isDateToday(vm.orgBookingTime, timezoneId);

  vm.showSectionSelector = false;

  vm.BookingMethods = BookingMethods;
  vm.isSectionChangedManually = false;
  vm.isPaymentLinkInfoValid = true;
  vm.isShorterContainerInEditBooking = false;
  // methods
  vm.cancel = cancel;
  vm.update = update;
  vm.sendSMS = sendSMS;
  vm.changeStatus = changeStatus;
  vm.editCustomer = editCustomer;
  vm.editBookingOptions = editBookingOptions;
  vm.updateLables = updateLables;
  vm.goBack = goBack;
  vm.seat = seat;
  vm.checkDuration = checkDuration;
  vm.changeTimeToNow = changeTimeToNow;
  vm.resetTime = resetTime;
  vm.toggleLocked = toggleLocked;
  vm.toggleCustomTime = toggleCustomTime;
  vm.addCustomer = addCustomer;
  vm.statusUpdate = statusUpdate;
  vm.editPrimaryTable = editPrimaryTable;
  vm.closePrimaryTable = closePrimaryTable;
  vm.getBookings = getBookings;
  vm.managePreAuth = managePreAuth;
  vm.querySearch = querySearch;
  vm.checkForStaffNameRequired = checkForStaffNameRequired;
  vm.onSendConfirmationUpdate = onSendConfirmationUpdate;
  vm.onSendSMSConfirmationUpdate = onSendSMSConfirmationUpdate;
  vm.onStandbyUpdate = onStandbyUpdate;
  vm.onStandbyReset = onStandbyReset;
  vm.onServiceSelected = onServiceSelected;
  vm.onTimeChanged = onTimeChanged;
  vm.handleTableIdsChange = handleTableIdsChange;
  vm.handleCustomerDetailsUpdate = handleCustomerDetailsUpdate;
  vm.handleCancelBooking = handleCancelBooking;
  vm.handleStandbyBtn = handleStandbyBtn;
  vm.disablePaymentType = disablePaymentType;
  vm.showBookingOptions = showBookingOptions;
  vm.updateBookingLink = updateBookingLink;
  vm.addBookingLink = addBookingLink;
  vm.showAllCustomerBookings = showAllCustomerBookings;
  vm.dialogContainer = null;
  vm.handleSendLinkPaymentResponseAndCloseOnSuccess = handleSendLinkPaymentResponseAndCloseOnSuccess;
  vm.updateWithoutClosing = updateWithoutClosing;
  vm.getBookingChangesByApiCssStyle = getBookingChangesByApiCssStyle;
  vm.openRecurringBooking = openRecurringBooking;
  vm.handleCancelRecurringBookings = handleCancelRecurringBookings;
  vm.calculateNumberOfRecurringBookings = calculateNumberOfRecurringBookings;
  vm.showMenuOptionsClear = showMenuOptionsClear;
  vm.removeBO = removeBO;
  vm.removeUO = removeUO;
  vm.changeSections = changeSections;
  vm.handleEmailSmsNotification = handleEmailSmsNotification;
  vm.isLockedBooking = false;
  vm.lockedIcon = 'mdi-lock-open';
  // Booked-By
  vm.validPaymentCustomer = true
  vm.bookedByCustomerDetails = {
    subscribed: !!vm.booking.bookedBy?.subscribed
  };
  vm.booking.bookedByNotify = {
    notifySms: false,
    notifyEmail: false,
  };
  vm.isBookedByValid = true;
  vm.setBookedByCustomerDetails = setBookedByCustomerDetails;
  vm.bookedByErrors = {};
  vm.setBookedByErrors = setBookedByErrors;
  vm.toggleBookedByWithEditBooking = toggleBookedByWithEditBooking;
  vm.isNoPayment = !vm.booking.paymentDetails || vm.booking.paymentDetails.paymentType === servicePaymentType.noPayment;


  const {fullStatusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
  vm.isStatusNameInList = () => {
    return StatusConfigService.checkStatusOptions(vm.statusName, [bookingStatusType.confirmed, bookingStatusType.unconfirmed], fullStatusOptions);
  }
  vm.isEwayAndNotWalkinBooking = vm.venue.paymentSettings?.paymentProvider === paymentProviderTypeUppercase.Eway && vm.booking.method !== BookingMethods.walkin && !vm.isNoPayment;
  const isSaveEnable = () => {
    vm.isSaveEnabled = vm.isPaymentLinkInfoValid && (vm.isBookedByValid || !vm.booking.isBookedBy) && vm.validPaymentCustomer;
  };
  const isPaymentLinkInfoValid = (isPaymentMobileValid, isPaymentEmailValid) => {
    vm.isPaymentLinkInfoValid = isPaymentMobileValid && isPaymentEmailValid;
    isSaveEnable();
  };
  /**
   * Adds 'tabVis' object for view model to use, with convenience method 'doShow'
   * for checking if enabled and visible.
   * Using 'doShow' as a function because 'isEnabled' and 'isVisible' get updated
   * after initialization.
   */
  vm.tabVis = TabSelectionService.getEditBookingTabsAsObject();

  vm.state = vm.LOADING;
  vm.additionalLoadingState = null; // this holds additional state for loading messages

  NetworkConnectionService.checkCouchDbIsReachable();

  GeneralSettingsService.get().then(function (s) {
    settings = s;
    init().then(r => {

      if (!vm.booking.paymentDetails) {
        // when first loading a booking from widget, the paymentDetails will be undefined, so we must set them
        vm.booking.paymentDetails = PaymentService.getPaymentDetailsFromWidgetBooking(vm.booking) || {paymentType: PaymentTypes.NoPayment};
      }

      vm.oldBooking = ObjectCopyService.angularSafeCopy(vm.booking);


      if (!vm.booking.preferredSectionId) {
        const notes = `Booking Data: {"_id": "${vm.booking._id}",
                      "_rev": "${vm.booking._rev}", "bookingType": "${vm.booking.bookingType}", "tables": "${vm.booking.tables}"}`;
        AdminService.serverLoggingDbEvents(AdminService.getVenue().id.toString(), 'SECTION_ID_ERROR - EDIT_BOOKING - Booking is being saved without a preferred section id', AdminServiceLog.WARNLOG, notes);
        console.warn('SECTION_ID_ERROR - NEW_BOOKING - preferred section is coming as null', vm.booking)
        vm.booking.preferredSectionId = SECTION_ANY_ID;
        vm.oldBooking.preferredSectionId = SECTION_ANY_ID; // setting old booking as well so they don't show up with differences, when user hasn't manually changed anything
      }

      vm.bookingLinks = vm.booking.bookingLinks || [];
      vm.validBookingLinks = BookingValidationService.determineValidBookingLinks(vm.bookingLinks);
      vm.initialBookingDtls = cloneDeep(vm.booking);
      vm.originalPaymentDetails = vm.booking.paymentDetails; // to keep the original payment - so that we can modify BO and upsellOptions several times in a single session

      vm.state = vm.ENTER;
      bookingReactRerender(); // needs to render react components that may have been hidden while loading (like notes)

      // this is a promise, but we don't need to wait for it to finish to stop the loader
      getCustomerAmountDetails();
      vm.showRecurringBooking = settings.enableRecurringBookings;

      if (AdminService.isPartnerBookingsLocked(vm.booking?.partner) === true) {
        showLockedBookingConfirmationDialog();
      }
    });
  });

  function changeSections() {
    vm.isSectionChangedManually = true;
  }

  /**
   * Because this controller gets added via $mdDialog, there is no default lifecycle hooks,
   * so this needs to get called from within the `onComplete` callback.
   */
  $scope.$onInit = () => {
    vm.phoneWithoutPrefix = vm.booking?.phone || '';
    vm.phoneInitial = vm.booking?.phone || '';
    verifyTabOrder();
  };

  async function init() {
    PaymentValidationService.init('', '', isPaymentLinkInfoValid);
    vm.guestListValid = true;


    // check couch
    AdminService.restartPeriodicCouchNameCheck(); // restarts the timer
    AdminService.loadVenue(vm.venue.id, true, true).catch(function (err) {
      console.error(err);

      AuthService.checkAuth().then((res) => {
        if (!res) {
          $mdDialog.cancel();
        }
      });
    });

    // settings
    vm.staffEditEnabled = (settings.staffEditEnabled && vm.booking.method !== BookingMethods.walkin) ? true : false;
    vm.staffEditRequired = staffEditRequiredFromSettings = (settings.staffEditRequired && vm.staffEditEnabled) ? true : false;
    // vm.staffEdit = (settings.staffEditRequired && vm.staffEditEnabled) ? settings.staffEdit : null;
    // if the new staff edit isnt selected by default we return null
    staffEditOptions = (settings.staffEdit && settings.staffEditRequired && vm.staffEditEnabled) ? settings.staffEdit : null;


    // tracking
    TrackingService.trackPageView('booking.edit');

    //-- add listeners
    addListeners();

    if (!vm.booking.tables || vm.booking.tables === null || vm.booking.tables.length === 0) {
      // this booking does not have any tables assigned it is on the wait list
      vm.onWaitList = true;
    }

    if (!isTouchDevice) {
      vm.showComplete = true;
    }

    getSectionsLookUp();
    getCustomer();
    setSelectedTableIds();

    /**
     * So that the schedule can be loaded before we can show the tabs.
     * Note that we're not waiting for vm.layouts or vm.bookings to populate, so the load time appears faster.
     */
    await getSchedule();

    getMaxBookingSize();
    generateBookingUrl();
    updateStatusList();
    getAllTags();
    updateShowTabs(true);

    // check if connection lost
    updateOfflineStatus();
    if (vm.allBookingOptions.length === 0) {
      vm.allBookingOptions = await BookingOptionsManagerService.getAll();
    }
    setBookingOptions(); // -> must come after updateShowTabs -> setActivePayments & vm.allBookingOptions

    // Decoding the notes which were already encoded and saved in the couch
    const decodedNotes = UtilsService.htmlDecode(vm.booking.notes);
    const booking = cloneDeep(vm.booking);
    vm.booking = {...booking, notes: decodedNotes};

    if (vm.booking.recurringBookingId) {
      RecurringBookingService.getRecurringBookings(vm.booking.recurringBookingId).then((response) => {
        vm.recurringBookings = response.bookings;
      });
    }

    let lockStatus = BookingsLockService.isBookingLockedByManagement(vm.booking);

    vm.isLockedBooking = lockStatus
    setLockIcon(lockStatus)
  }

  function setLockIcon(locked) {
    vm.lockedIcon = locked ? 'mdi-lock' : 'mdi-lock-open'
  }

  function addListeners() {
    listeners.push($scope.$watch('editBooking.selectedTimeId', timeChange));
    listeners.push($scope.$watch('editBooking.booking.people', bookingChange));
    listeners.push($scope.$watch('editBooking.booking.people', () => {
      updateShowTabs(false);
      setBookingOptions(); // -> must come after updateShowTabs -> setActivePayments
    }));
    listeners.push($scope.$watch('editBooking.booking.duration', bookingChange));
    listeners.push($scope.$watch('editBooking.booking.preferredSectionId', (value, oldValue) => {
      vm.sectionMessage = "";
      if(booking.bookingType === BookingType.Booking){
        getErrorMessage('table');
      }
      bookingChange(value, oldValue);
    }));
    listeners.push($scope.$watch('editBooking.selectdTableIds', bookingTableChange));
    listeners.push($scope.$on('tags-updated', updateLables));
    listeners.push($scope.$watch('editBooking.booking.tags', updateLables));
    listeners.push($scope.$watch('editBooking.booking.notes', updateLables));
    listeners.push($scope.$watch('editBooking.customer.notes', updateLables));
    listeners.push($scope.$watch('editBooking.customer.managerNotes', updateLables));
    listeners.push($scope.$watch('editBooking.booking.tags.length', updateLables));
    listeners.push($scope.$watch('editBooking.serviceId', serviceChange));
    listeners.push($scope.$watch('editBooking.booking.paymentDetails.paymentType', paymentTypeChange));
    listeners.push($scope.$watch('editBooking.booking.paymentDetails.price', priceChange));

    vm.dialogContainer = element[0].querySelector(".md-dialog-container");
    vm.dialogContainer.addEventListener('click', canShowConfirmationDialog);
    vm.dialogContainer.addEventListener('touchstart', canShowConfirmationDialog);

    listeners.push($scope.$on('$destroy', () => {
      removeConfirmationDialogListener();
      unregister(listeners);
    }));
  }

  function setSelectedTableIds() {
    // define section ids
    if (vm.booking.tables) {
      for (var i = 0; i < vm.booking.tables.length; i++) {
        var table = vm.booking.tables[i];
        if (table) {
          vm.selectdTableIds.push(table._id);
        }
      }
    }
  }

  /**
   * Removes the click and touchstart event listener
   */
  function removeConfirmationDialogListener() {
    vm.dialogContainer.removeEventListener('click', canShowConfirmationDialog);
    vm.dialogContainer.removeEventListener('touchstart', canShowConfirmationDialog);
  }

  /**
   * Determine whether to show the confirmation dialog, when clicked outside the form.
   */
  function canShowConfirmationDialog(e) {

    // Do not compare, when not clicked outside the dialog
    if (e.target.className !== "md-dialog-container") return;

    // Display the dialog when the form is loaded and has unsaved data
    if (vm.initialBookingDtls.serviceId && vm.state === vm.ENTER && doesBookingFormHaveUnsavedData(e)) {
      showSaveConfirmationDialog();
    } else {
      /**
       * When you click on the "CLOSE" button in the confirmation dialog, the EditBooking form dialog is closed.
       * But, if you quickly click on the EditBooking form dialog while it's closing, the confirmation dialog is opened again due to the click event listener.
       * So, calling the remove listener to avoid opening the confirmation dialog again.
       */
      removeConfirmationDialogListener();

      // Close the EditBooking form
      cancelDialog();
    }
  }

  /**
   * Detect unsaved data by comparing the initial and new data.
   */
  function doesBookingFormHaveUnsavedData() {

    // Compare booking details
    const booking = cloneDeep(vm.booking);
    if (!CompareObjectsService.hasIdenticalData(booking, vm.initialBookingDtls)) return true;

    // Compare selected service
    if (vm.serviceId !== FunctionTrackerInfo.id && vm.serviceId !== vm.initialBookingDtls.serviceId) return true;

    // Check send confirmation
    if (vm.sendConfirmation) return true;

    // Compare customer details
    const customer = cloneDeep(vm.customer);
    if (!CompareObjectsService.hasIdenticalData(customer, orgCustomer)) return true;

    // Compare booking links
    if (vm.initialBookingDtls.bookingLinks && vm.bookingLinks.length !== vm.initialBookingDtls.bookingLinks.length) return true;
    const bookingLinks = cloneDeep(vm.bookingLinks);
    if (!CompareObjectsService.hasIdenticalData(bookingLinks, vm.initialBookingDtls.bookingLinks)) return true;

    return false;
  }

  /**
   * Display save booking confirmation dialog
   */
  function showSaveConfirmationDialog() {
    const dialogMessage = "This booking is incomplete or has not been saved.\nBy pressing close, you will lose changes you have made. By pressing continue, you can continue making changes.";
    const headerMsg = 'Save confirmation';
    SimpleDialogActions.showDialog({
      description: dialogMessage,
      title: headerMsg,
      confirmText: 'Continue',
      rejectText: 'Close',
      handleConfirm: () => {
        SimpleDialogActions.hideDialog();
      },
      handleReject: cancelDialog
    });
  }
  function showUpdatePaymentLinkInfoConfirmationDialog () {
    let tempCustomer = vm.customer;
    const diffInfoList = CustomerService.checkDifference(tempCustomer,
      {...tempCustomer, email: PaymentValidationService.isPaymentEmailUpdateChecked ? PaymentValidationService.paymentEmail : tempCustomer?.email,
        phone: PaymentValidationService.isPaymentPhoneUpdateChecked ? PaymentValidationService.paymentPhone : tempCustomer?.phone});
    const dialogMessage = `You are about to update an existing customer record, would you like to proceed? <div>Current Details: ${tempCustomer.fullName || ''} ${tempCustomer.phone && tempCustomer.phone.trim() != '' ? `(${tempCustomer.phone})` : ''} ${tempCustomer.email || ''}</div>`;
    const headerMsg = 'Save confirmation';

    SimpleDialogActions.showDialog({
      description: dialogMessage,
      title: headerMsg,
      confirmText: 'Continue',
      rejectText: 'Cancel',
      handleConfirm: () => {
        vm.isPaymentLinkPopupConfirmed = true;
        update();
        SimpleDialogActions.hideDialog();
      },
      handleReject: () => {
        SimpleDialogActions.hideDialog();
      },
      diffInfoList
    });
  }
  function showLockedBookingConfirmationDialog() {
    const dialogMessage = `${vm.booking.partner} events must be edited in ${vm.booking.partner}. ${vm.booking.bookingLinks !== undefined && vm.booking.bookingLinks?.length > 0 ? `Please uses this link to make changes:\n<a href="${vm.booking.bookingLinks[0].linkURL}">${vm.booking.bookingLinks[0].linkName}</a>` : ""} `
    const headerMsg = 'Lock Partner Bookings';

    const props = {
      title: headerMsg,
      description: dialogMessage,
      isOpen: true,
      confirmText: '',
      rejectText: 'Dismiss',
      handleConfirm: () => {},
      handleReject: () => {
        SimpleDialogActions.hideDialog();
      }
    }
    SimpleDialogActions.showDialog(props)
  }

// check payment Change  if any
  function paymentTypeChange(val, oldVal) {
    if (val === oldVal) {
      return;
    }
    if (vm.booking.paymentDetails && vm.booking.paymentDetails.paymentType !== PaymentTypes.NoPayment) {
      if (vm.customer.email || vm.customer.phone) {
        vm.validPaymentCustomer = true
      } else {
        vm.validPaymentCustomer = false
      }
      if (vm.paymentUrl === "") {
        vm.hasPriceChanges = true;
      }
      if (!vm.booking.paymentDetails.price) {
        vm.booking.paymentDetails.price = 0;
      }
    } else {
      vm.validPaymentCustomer = true
    }
    isSaveEnable()
    setStandbyPendingPayment();
  }

  // check price change if any
  function priceChange(currentPrice, oldPrice) {
    if (currentPrice === oldPrice) {
      return;
    }
    setStandbyPendingPayment();

    if (vm.paymentUrl === "") {
      vm.hasPriceChanges = true;
      return;
    }
    // get original price
    let oriPrice = vm.oldBooking && vm.oldBooking.paymentDetails && vm.oldBooking.paymentDetails.price;
    if (!oriPrice) {
      oriPrice = 0;
    }
    if (oriPrice === currentPrice) {
      if (vm.hasPriceChanges !== false) {
        vm.hasPriceChanges = false;
      }
      return;
    }
    // check changes
    if (!currentPrice) {
      currentPrice = 0;
    }
    if (!oldPrice) {
      oldPrice = 0;
    }
    if (currentPrice !== oldPrice) {
      vm.hasPriceChanges = true;
    } else {
      vm.hasPriceChanges = false;
    }
  }


  function setStandbyPendingPayment() {
    const {isSBPaymentUnconfirmed} = StatusService.getStandbyPaymentPendingState(vm.booking.status.statusType, vm.booking.paymentDetails, vm.booking.bookingType);
    if (isSBPaymentUnconfirmed) {
      vm.statusName = StatusServiceInstance.updateBookingStatusWithPaymentPendingUnconfirmed(vm.booking);
    }

    updateStatusList();
    statusUpdate(false);
  }

  function updateStatusList() {
    vm.statusOptions = StatusServiceInstance.getFilteredStatusList(vm.statusName, vm.booking);
  }


  function checkForStaffNameRequired() {
    vm.staffEditRequired = staffEditRequiredFromSettings && !StaffService.staffNameNotRequired({
      oldBooking: vm.oldBooking, newBooking: vm.booking, staffEnabled: vm.staffEditEnabled, waitList: false,
      staffEditOptions, orgCustomer, updatedCustomer: vm.customer});// To make sure Staff name is not mandatory if the status has been changed to seated
    return vm.staffEditRequired;
  }

  function updateShowTabs(isFirstRun) {

    // always hidden (I guess this is just for takeaway) @todo: check with Jem if this is needed and if just for TA with deliveries on the service
    TabSelectionService.updateEditBookingTabEnabled(EditBookingTabs.deliveryAddress, vm.venue.isTakeAwayMode); // vm.venue.isTakeAwayMode

    // Show details for a not registered customer (es Walk In)
    const hasCustomer = !!vm.booking.customerId;
    TabSelectionService.updateEditBookingTabVisibility(EditBookingTabs.details, !hasCustomer);

    vm.activePaymentDetails = PaymentService.setActivePayments(vm.service.paymentDetails, vm.service.additionalPaymentDetails,
      vm.booking.people, vm.booking.time); // -> must go before setting tab visibility for upsell and booking options

    if (isFirstRun) {
      vm.originalBOIds = cloneDeep(vm.activePaymentDetails?.menuOptions);
      vm.originalUOIds = cloneDeep(vm.activePaymentDetails?.menuOptionsUpsell);
    }

    const currentBookingHasBookingOptions = MenuOptionsService.hasBookingOptions(false, vm.booking.selectedOptions, vm.booking.selectedMenuOptions);
    const currentBookingHasUpsell = MenuOptionsService.hasBookingOptions(true, vm.booking.selectedOptions, vm.booking.selectedMenuOptions);

    const isUpsellVisible = currentBookingHasUpsell || vm.activePaymentDetails && !isEmpty(vm.activePaymentDetails.menuOptionsUpsell);
    TabSelectionService.updateEditBookingTabVisibility(EditBookingTabs.upsellOptions, isUpsellVisible || vm.originallyHadUpsell);

    const isBOVisible = currentBookingHasBookingOptions || vm.activePaymentDetails && !isEmpty(vm.activePaymentDetails.menuOptions);
    TabSelectionService.updateEditBookingTabVisibility(EditBookingTabs.bookingOptions, isBOVisible || vm.originallyHadBookingOptions);

    TabSelectionService.updateEditBookingTabVisibility(EditBookingTabs.paymentSummary, vm.booking.paymentSummary &&
      (vm.booking.paymentSummary.transactionId ||
        vm.booking.paymentSummary.paymentType === PaymentTypes.PreAuth
      )
    );

    // The venue is configured for payments and there's no payment summary or it is not payied and not of type PreAuth
    TabSelectionService.updateEditBookingTabVisibility(EditBookingTabs.paymentDetails, vm.venue.isPaymentsConfigured &&
      (vm.booking.paymentSummary == null ||
        (vm.booking.paymentSummary.transactionId == null &&
          vm.booking.paymentSummary.paymentType !== PaymentTypes.PreAuth
        ))
    );

    // Booking History
    TabSelectionService.updateEditBookingTabVisibility(EditBookingTabs.bookingHistory, hasCustomer);

    // Venue History (sets enabled, not visibility, as visibility is determined by venueVisitHistory length)
    TabSelectionService.updateEditBookingTabEnabled(EditBookingTabs.venueVisitHistory, hasCustomer && AdminService.getVenue().isOnlineCustomersEnabled);

    if (isFirstRun) {
      vm.originallyHadBookingOptions = currentBookingHasBookingOptions;
      vm.originallyHadUpsell = currentBookingHasUpsell;
    }
  }

  function getMaxBookingSize() {
    const isManager = ManagerService.isManager;
    vm.maxBookingSize = 1000000000000;
    if (!isManager) {
      if (settings && settings.restrictedMaxBookingSize) {
        vm.maxBookingSize = settings.restrictedMaxBookingSize;
        if (vm.maxBookingSize < booking.people) {
          vm.maxBookingSize = booking.people;
        }
      }
    }
  }

  function toggleCustomTime() {
    vm.customTime = !vm.customTime;
  }

  function statusUpdate(isManualUpdate) {
    const {statusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
    const status = statusOptions.find(({name}) => vm.statusName === name);
    if (status) {
      vm.booking.status = status;
      vm.booking.statusForRevertFinishAll = undefined;

      //If booking is being edited, reset cancel reason to default.
      vm.booking.cancelledReason = BookingCancelledReason.unspecified;

      // if manually changed to confirmed or seated, then we force it to a normal bookingType
      if (isManualUpdate &&
        (vm.statusName === BookingStatusNames.Confirmed || vm.statusName === BookingStatusNames.Seated)
      ) {
        vm.booking.bookingType = BookingType.Booking;
      }
    }
    bookingReactRerender();
  }

  function getChanges() {
    if (!vm.bookingChanges) {
      vm.extraInfoLoaded = true;
      vm.bookingsChangesLoading = true;
      vm.bookingChanges = false;
      BookingChangeService.getChanges(vm.booking).then(function (changesObj) {
        vm.bookingsChangesLoading = false;
        vm.bookingChanges = changesObj.changes;
      }).catch(function () {
        vm.bookingChanges = false;
        vm.bookingsChangesLoading = false;
      });
      getCustomerHistory();
    }
  }

  function getCustomerHistory() {
    vm.customerHistoryLoading = true;
    if (vm.booking.customerId) {
      var ids = vm.customer ? (vm.customer.venueIds || []).concat(vm.customer._id) : [vm.booking.customerId];
      return BookingLookupService.getBookingsByCustomerIds(ids, true).then(customerBookings => {
        const customerBookingList = $filter('orderBy')(customerBookings, 'time', true);
        vm.customerBookings = customerBookingList;
        vm.filteredCustomerBookings = customerBookingList.filter(booking => BookingValidationService.isValidPastBooking(booking));
        vm.customerHistoryLoading = false;
      }).catch(function () {
        vm.customerBookings = false;
        vm.customerHistoryLoading = false;
      });
    } else {
      vm.customerBookings = [];
      vm.customerHistoryLoading = false;
      return Promise.resolve();
    }
  }

  function getVenueVisitHistory() {
    vm.venueVisitHistoryLoading = true;
    if (vm.booking.customerId) {
      CustomerLookupService.getVenueVisitHistory(vm.booking.customerId).then(venueVisitHistory => {
        vm.venueVisitHistory = venueVisitHistory;
        vm.venueVisitHistoryLoading = false;
        setVenueVisitHistoryTabVisibility();
      }).catch(function () {
        vm.venueVisitHistory = false;
        vm.venueVisitHistoryLoading = false;
        setVenueVisitHistoryTabVisibility();
      });
    } else {
      vm.venueVisitHistory = [];
      vm.venueVisitHistoryLoading = false;
      setVenueVisitHistoryTabVisibility();
    }
  }

  function setVenueVisitHistoryTabVisibility() {
    TabSelectionService.updateEditBookingTabVisibility(EditBookingTabs.venueVisitHistory, vm.venueVisitHistory && vm.venueVisitHistory.length);
  }

  function toggleLocked() {
    BookingsLockService.toggleLockBookingForManagement(vm.booking, (locked) => {
      if (!locked) {
        vm.showFunctionTrackerAlertDialog = true;
      }

      if (!locked) {
        vm.isLockedBooking = false
      }

      setLockIcon(locked)
    })
  }

  function closeFunctionTrackerAlertDialog() {
    vm.showFunctionTrackerAlertDialog = false;
  }

  function checkDuration() {
    // @todo: use BookingNormaliseService.checkDuration (same as new booking details
    if (vm.booking.duration < vm.minBookingDuration || !vm.booking.duration) {
      vm.booking.duration = vm.minBookingDuration;
    }
  }

  function getSectionsLookUp() {
    SectionLookupService.getSectionsLookUp()
      .then(sections => {
        vm.sectionsLookup = sections;
      })
      .catch(err => {
        $log.error('error getSectionsLookUp', err);
      });
  }

  function goBack() {
    vm.state = vm.ENTER;
  }

  function changeStatus($status) {
    vm.booking.statusCode = $status.code;
    vm.booking.statusName = $status.name;
  }

  /**
   * The bookings details have changed update the available times
   * @param  value
   * @param  oldValue
   */
  function bookingChange(value, oldValue) {
    if (bookingsByTable && value !== oldValue) {
      calulateBookingTimes();
    }
  }

  function updateLables() {
    vm.tagsLabel = '0';
    if (vm.booking.tags && vm.booking.tags.length) {
      vm.tagsLabel = vm.booking.tags.length;
    }
    var notesItems = [];
    if (vm.booking.notes) {
      notesItems.push('Booking');
    }
    if (vm.customer && vm.customer.notes) {
      notesItems.push('Customer');
    }
    if (vm.customer && vm.customer.managerNotes && vm.isManager) {
      notesItems.push('Manager');
    }
    vm.notesLabel = '';
    if (notesItems.length) {
      vm.notesLabel = notesItems.join(', ');
    }
  }

  function bookingTableChange(selectdTableIds, oldValue) {
    if (selectdTableIds !== oldValue) {
      console.log(NS, 'bookingTableChange - vm.selectdTableIds', selectdTableIds)
      if (vm.booking.bookingType === BookingType.Booking || vm.booking.bookingType === BookingType.StandbyList) {
        updateTables();
      }
      checkTablesSelection();
    }
  }

  function updateTables() {
    const tablesToCheck = vm.selectFromTablesOptions || vm.tables;

    // the tables can be selected from sblSelectedTableIds or selectdTableIds
    if ( vm.sblSelectedTableIds.length > 0) {
      vm.booking.tables = TableSelectionService.getSelectedTablesFromList(tablesToCheck, vm.sblSelectedTableIds);
    } else {
      vm.booking.tables = TableSelectionService.getSelectedTablesFromList(tablesToCheck, vm.selectdTableIds);
    }

    // Load table details for the first time
    if (!vm.hasTableLoaded && vm.initialBookingDtls) {
      vm.initialBookingDtls.tables = cloneDeep(vm.booking.tables);
      vm.hasTableLoaded = true;
    }

    // Don't do anything if Section is changed manually
    if (vm.isSectionChangedManually) {
      bookingReactRerender();
      vm.isSectionChangedManually = false;
      return;
    }
    let sectionId = '';
    // Update section if table is selected
    // Cos There is no table assigned to StandbyList and preferredSectionId will be 'any' as default
    // even the booking is already assigned to particular section
    if (vm.booking.bookingType !== BookingType.StandbyList) {
      sectionId = SectionsService.getSectionFromPrimaryTable(vm.booking.primaryTableId, vm.booking.tables);
      vm.booking.preferredSectionId = sectionId;
    }
    vm.initialBookingDtls.preferredSectionId = sectionId;
    // // triggers refresh
    bookingReactRerender();
  }

  /**
   *
   * @param {boolean} now
   * @param {boolean} sms
   */
  function seat(now, sms) {

    /**
     * we also need to check whether SBL has selected tableIds, otherwise when it's SBL, the bellow "if" condition will not fulfilled,
     * all the functions inside will not be executed
     */
    if (vm.selectdTableIds.length || vm.sblSelectedTableIds.length) {
      var newStatusName = null;
      if (now) {
        vm.booking.time = seatNowTime;
        newStatusName = BookingStatusNames.Seated;
      }
      vm.booking.bookingType = BookingType.Booking; // needs this if coming from a standby booking
      updateTables();
      newStatusName = (sms) ? BookingStatusNames.SentSms : newStatusName;
      // triggers refresh
      bookingReactRerender();

      update(newStatusName, true).then((success) => {
        if (success && sms) {
          sendSMS(true);
        }
      });
    }

  }

  function sendSMS(dontClose) {

    var phone = (vm.customer && vm.customer.phone) ? vm.customer.phone : vm.booking.phone;
    SmsService.send(vm.booking, phone, null);
    if (!dontClose) {
      $timeout(function () {
        closeDialog();
      }, 300);
    }
  }

  function closeDialog(isHardClose = true) {
    ViewActionsService.onEditBookingClosed(isHardClose);
    NetworkConnectionService.checkCouchDbIsReachable();
    $mdDialog.hide();
  }

  function cancelDialog(isHardClose = true) {
    ViewActionsService.onEditBookingClosed(isHardClose);
    NetworkConnectionService.checkCouchDbIsReachable();
    $mdDialog.cancel();
  }

  function editCustomer(evt) {

    closeDialog(false);

    setTimeout(() => { // needs delay so onEditBookingClosed has time

      ViewActionsService.onEditCustomerOpened();
      updateOfflineStatus();
      $mdDialog.show({
        controller: 'EditCustomer',
        controllerAs: 'editCustomer',
        templateUrl: 'app/customers/edit/editCustomer.html',
        locals: {
          customer: vm.customer,
          isOffline: vm.isOffline,
          handleNewCustomerSelected: null
        },
        clickOutsideToClose: true,
        targetEvent: evt,

        onComplete: function ($scope) {
          $scope.editCustomer.showComplete = true;
        },

        onRemoving: function () {
          ViewActionsService.onEditCustomerClosed(false);
          $timeout(function () {
            BookingLookupService.getById(vm.booking._id, vm.booking.time)
              .then(booking => {
                vm.booking._rev = booking._rev;
                const skipOriginal = true; // don't want to reset the orgBooking, so must instruct event to skip that
                $rootScope.$broadcast('edit-booking', evt, vm.booking, skipOriginal);
              });
          }, 500);
        }

      });
    }, 500);

  }

  async function editBookingOptions(evt, isUpsell = false) {
    if (vm.activePaymentDetails) {
      const tempOptions = isUpsell ? vm.activePaymentDetails.menuOptionsUpsell : vm.activePaymentDetails.menuOptions;
      const menuOptions = tempOptions ? MenuOptionsService.getMenuOptionDetailsFromIds(tempOptions, vm.allBookingOptions) : [];
      const newOptions = isUpsell ? {optionsUpsell: menuOptions} : {options: menuOptions};
      const paymentDetails = {...vm.activePaymentDetails, ...newOptions};
      const selectedMenuOptions = vm.booking.selectedOptions ? SharedBookingService.convertSelectedBookingOptions(vm.booking.selectedOptions) : [];
      const booking = {...vm.booking, selectedMenuOptions};
      MenuOptionReducerService.setBooking(ObjectCopyService.angularSafeCopy(booking));
      MenuOptionReducerService.setActiveService({...vm.service});
      MenuOptionReducerService.setEditCachedMenuOptionDetails(updateMenuOptionCachedDetails(vm.allBookingOptions));

      $mdDialog.show({
        controller: 'EditBookingOptions',
        controllerAs: 'vm',
        templateUrl: 'app/bookings/bookingOptionsTab/edit/editBookingOptions.html',
        locals: {
          booking: booking,
          paymentDetails: paymentDetails,
          maxCovers: booking.people,
          serviceId: booking.serviceId,
          currency: vm.venue.currency,
          bookingTimes: vm.bookingTimes,
          bookingDate: vm.selectedTime,
          isUpsell: isUpsell
        },
        clickOutsideToClose: true,
        targetEvent: evt,
        skipHide: true,
        onComplete: function ($scope) {
          $scope.$onInit();
        },
      }).then(
        function (newSelectedMenuOptions) {
          if (newSelectedMenuOptions) {
            const existingMenuOptions = SharedBookingService.convertSelectedBookingOptions((vm.booking.selectedOptions || []).filter(t => t.isUpsellItem === !isUpsell));

            // combines with existing and runs equality check on objects to prevent duplicates
            const newMenuOptions = uniqWith(existingMenuOptions.concat(newSelectedMenuOptions), isEqual);

            updatePaymentBasedOnBookingOptions(newMenuOptions);
            vm.booking.selectedMenuOptions = MenuOptionsServiceShared.getFlatExtras(newMenuOptions);
            vm.booking.selectedOptions = MenuOptionsService.updateSelectedOptions(cloneDeep(vm.booking.selectedMenuOptions), vm.allBookingOptions);
            vm.selectedBookingOptions = MenuOptionsService.filterBookingOptionsNonUpsell(vm.booking.selectedOptions);
            vm.selectedUpsellOptions = MenuOptionsService.filterBookingOptionsUpsell(vm.booking.selectedOptions);
            vm.booking.tags = TagsService.mergeAndGetUniqueTags(vm.booking.selectedOptions, vm.allTags, vm.booking.tags); // Getting the tags from BO and children
            vm.originalBOIds = vm.selectedBookingOptions.map(opt => opt.id);
            vm.originalUOIds = vm.selectedUpsellOptions.map(opt => opt.id);
            if (isUpsell) {
              upsellOptionsValid = true;
            } else {
              bookingOptionsValid = true;
            }
            vm.disableSaveForPaxThreshold = !bookingOptionsValid || !upsellOptionsValid;

            bookingReactRerender();
          }
        },
        function (cancelData) {
        });
    }
  }

  function updateMenuOptionCachedDetails(allBookingOptions) {
    return allBookingOptions.map(option => ({...option, id: option._id}));
  }

  function updatePaymentBasedOnBookingOptions(selectedMenuOptions) {
    if (!vm.selectedTime || !vm.bookingTimes) {
      return;
    }

    if (paymentTypeSubs) { // stops spamming
      paymentTypeSubs.unsubscribe();
    }

    // Makes sure BOs have same qty as booking pax when singleMenuPerBooking
    MenuOptionsService.setBOPaxWhenSingleMenuPerBooking(selectedMenuOptions, vm.activePaymentDetails, vm.booking.people);

    const hasBO = MenuOptionsService.hasBookingOptions(false, [], selectedMenuOptions);
    const hasUpsell = MenuOptionsService.hasBookingOptions(true, [], selectedMenuOptions);
    const bypassValidation = hasUpsell && !hasBO;
    paymentTypeSubs = PaymentService.getBookingPaymentDetailsFromServiceAndBookingOptions(
      selectedMenuOptions, vm.service._id, vm.selectedTime, vm.bookingTimes, vm.booking.people, bypassValidation
    )
      .pipe(first())
      .subscribe(paymentDetails => {
        if (paymentDetails) {
          vm.booking.paymentDetails = paymentDetails;
        } else {
          // @todo: handle error
        }
      });
  }

  function addCustomer(evt) {
    updateOfflineStatus();
    $mdDialog.show({
      controller: 'AddCustomerDialogCtrl',
      controllerAs: 'vm',
      locals: {
        booking: vm.booking,
        customer: vm.customer,
        isOffline: vm.isOffline,
      },
      clickOutsideToClose: true,
      templateUrl: 'app/customers/add/addCustomerDialog.html',
      targetEvent: evt,

      onRemoving: function () {
        $timeout(function () {
          BookingLookupService.getById(vm.booking._id, vm.booking.time)
            .then(booking => {
              vm.booking._rev = booking._rev;
              if (booking.customerId) {
                vm.booking.customerId = booking.customerId;
                CustomerLookupService.getById(vm.booking.customerId).then((customer) => {
                  vm.customer = customer;
                  orgCustomer = ObjectCopyService.angularSafeCopy(customer);
                  updateBookingCustomerInfo(true);
                  $rootScope.$broadcast('edit-booking', evt, vm.booking);
                });
              } else {
                vm.booking.firstName = booking.firstName;
                vm.booking.phone = booking.phone;
                $rootScope.$broadcast('edit-booking', evt, vm.booking);
              }
            });
        }, 500);
      }
    });
  }

  function updateOfflineStatus() {
    // if connection has already been lost, status isn't changed
    if (AdminService.getVenue().isOnlineCustomersEnabled && !NetworkConnectionService.isOnline()) {
      vm.isOffline = true;
    }
  }

  /**
   * Get the schedule for the date selected
   */
  function getSchedule() {
    return new Promise(resolve => {

      vm.selectFromTables = [];
      // Schedule
      ScheduleLookupService.getSchedule(vm.bookForDate)
        .then((schedule) => {
          vm.schedule = schedule;
          if (schedule) {
            parseSchedule();
            MenuOptionReducerService.setActiveService({...vm.service});
            resolve();
          } else {
            MenuOptionReducerService.setActiveService(null);
            resolve();
          }
        });
    });
  }

  function editPrimaryTable() {
    vm.showEditPrimaryTable = true;
  }

  function closePrimaryTable() {
    vm.showEditPrimaryTable = false;
  }

  function parseSchedule() {

    var service, serviceStartDate, serviceEndDate;

    // select the appropriate service;
    const matchedService = ServicesLookupService.getServiceFromSchedule(vm.schedule, vm.bookForDate, vm.booking.serviceId)
    vm.service = matchedService
    vm.serviceId = matchedService ? matchedService._id : "";

    // build a list of the service that are in use
    const {serviceViewList} = ServicesLookupService.buildServiceViewList(vm.schedule.serviceLayouts, vm.schedule.services)

    // no service found the schedule must have been changed
    // find the closet service.
    if (!vm.service) {
      const closetService = ServicesLookupService.getClosestService(vm.schedule, vm.bookForDate)
      vm.serviceId = closetService ? closetService._id : "";
      vm.service = closetService;
      vm.showAutoServiceSelectMessage = !!closetService;
    }

    if (vm.service) {
      getLayouts(); // not waiting for this to finish, so it speeds up component's load time
    } else {
      if (!vm.setUp) {
        t1 = performance.now();
        TelemetryService.track('editBookingSetUp', [
          ['duration', t1 - t0]
        ]);
      }
      vm.setUp = true;
    }

    // Add and select "Function Tracker" service option, incase of the function tracker booking
    if (vm.booking.functionTracker) {
      const functionTracker = ServicesLookupService.getFuntionTrackerInfo(serviceViewList)
      vm.serviceId = functionTracker.id;
      serviceViewList.push(functionTracker.serviceViewListItem);
    }

    vm.serviceViewList = serviceViewList;
  }

  /**
   * Gets all layout used in the current service
   */
  function getLayouts() {
    if (vm.service) {
      var layoutsIds = [];
      for (var i = vm.service.sectionLayouts.length - 1; i >= 0; i--) {
        layoutsIds.push(vm.service.sectionLayouts[i].layoutId);
      }

      return LayoutsService.getLayouts(layoutsIds, vm.bookForDate).then(function (layouts) {
        vm.layouts = layouts;
        // Get bookings
        return getBookings(); // depends on vm.layouts
      });
    }
  }

  /**
   * Gets all bookings for the given date
   */
  function getBookings() {
    if (vm.schedule) {
      // @todo: figure out why paymentDetails get set to NoPayment here when status is confirmed. severity:high
      return BookingLookupService.getBySchedule(vm.schedule).then(function (results) {
        vm.bookings = $filter('orderBy')(results.bookings, 'time');
        // Get tables
        return getTables();
      }).catch(function (err) {
        console.log(NS, 'getBookings', err);
        vm.state = vm.ERROR_LOADING;
      });
    }
  }

  function serviceChange(value, oldValue) {
    if (vm.serviceId && bookingsByTable && value !== oldValue) {
      vm.service = vm.schedule.services.find(({_id}) => _id === vm.serviceId);
      MenuOptionReducerService.setActiveService(vm.service);
      // vm.service = vm.schedule.services[parseInt(vm.serviceId)];
      getTables();
      vm.activePaymentDetails = PaymentService.setActivePayments(vm.service.paymentDetails, vm.service.additionalPaymentDetails,
        vm.booking.people, vm.booking.time);
    }
  }

  function getTables() {
    vm.sectionMessage = "";

    //move to function getLayoutIdsFromServices in ServicesLookupService of submodule
    const layoutsIds = ServicesLookupService.getLayoutIdsFromServices(vm.schedule?.services, vm.service.sectionLayouts, vm.booking.time, vm.booking.functionTracker);
    return LayoutsService.getByLayouts(layoutsIds, vm.bookingDate).then(function (results) {
      var tables = results.tablesArray;
      vm.tables = tables;
      return getSectionIdsList(tables);
    }).then(function (sectionIds) {
      // Get sections
      return SectionLookupService.getSectionsByIds(sectionIds); // @todo: this is quite an expensive process - maybe we can cache it somehow? Severity: medium
    }).then(function (sections) {
      vm.showSectionSelector = sections.length > 1;

      if (sections[0] && sections[0]._id !== vm.booking.preferredSectionId && vm.booking.preferredSectionId !== SECTION_ANY_ID) {
        /**
         * If there is only 1 section and it is not preselected, indicates a problem, so we must show section
         * selector so the user can correct it.
         */
        vm.showSectionSelector = true;
      }

      sections.unshift({
        _id: 'any',
        name: 'Any',
      });

      vm.sections = sections;
      getErrorMessage();
      // calculate booking by tabe;
      createBookingsByTable();
      // get booking taimes
      calulateBookingTimes();


      if (vm.booking.tables?.length > 0 && settings.enableMaxOccupancy && vm.bookingTimes) {
        vm.coversBookingIntervals = BookingIntervalService.getCoversPerMinuteInterval(cloneDeep(vm.bookingTimes), vm.bookings, vm.sections);
      }
    });
  }

  function getErrorMessage(type = 'section') {
    const sectionData = vm.sectionsLookup[vm.booking.preferredSectionId];
    const tableNames = booking.tables.map(t => t.name + (booking.tables.length > 1 ? ', ' : ''));
    if (type === 'section') {
      if (!vm.sections.some(s => s && s._id === vm.booking.preferredSectionId)) {
        vm.sectionMessage = `Cannot populate section because the booking's service "${vm.service.name}" does not match the selected section (${sectionData?.name}) of the booking.`;
      }
    }
    else {
      const tableSections = booking.tables?.map(t => t.sectionId) || [];
      if (!tableSections.some((s)=> checkForAvailableSections(s, vm.sections))){
        vm.sectionMessage = `Cannot populate table because the booking's service "${vm.service.name}" does not match the selected table (${ 'T' + tableNames}) of the booking.`;
      }
    }
  }

  function checkForAvailableSections(sectionId, sections) {
    return sections?.some(s => s && s._id === sectionId)
  }

  function createBookingsByTable() {
    // create a bookings by table without the current booking so it is a vaild booking
    var index = vm.bookings.map(function (e) {
      return e._id;
    }).indexOf(vm.booking._id);
    if (index > -1) {
      // remove booking
      vm.bookings.splice(index, 1);
    }

    bookingsByTable = BookingAvailabilityService.getBookingsByTable(vm.bookings);
  }

  function calulateBookingTimes() {
    if (vm.booking.bookingType === BookingType.WaitList && vm.booking.method === BookingMethods.walkin) {
      // this is a walkin only find empty tables for right now
      /**
       * move to setSeatNowTime function in booking-availability-service of submodule
       * the if condition is conflict between outside and inside
       * 'vm.booking.method !== 'walkin' || !vm.isDateToday', also conflict, coz 'walkin' only in today's booking.
       *
       */
      // seatNowTime = DateUtilsService.getVenueTime(timezoneId);
      // seatNowTime.setSeconds(0);
      // seatNowTime.setMilliseconds(0);
      // if (vm.booking.method !== 'walkin' || !vm.isDateToday) {
      //   seatNowTime = vm.booking.time;
      //   //$scope.$watch('editBooking.booking.time', calulateBookingTimes);
      // }

      seatNowTime = BookingAvailabilityService.setSeatNowTime(vm.isDateToday, timezoneId);


      if (seatNowTime) {
        vm.selectedTime = BookingAvailabilityService.checkBookingsAtTime(
          seatNowTime,
          vm.bookingDate,
          vm.schedule,
          vm.service,
          vm.layouts,
          vm.booking.duration,
          vm.booking.people,
          vm.tables,
          bookingsByTable,
          vm.booking.preferredSectionId,
          null,
          true
        );
        // move to function getSelectedTableIds in TableSelectionService
        vm.selectdTableIds = TableSelectionService.getSelectedTableIds(vm.selectedTime);


        createTableSectionList();
      }
    } else {
      const bookingTimes = BookingAvailabilityService.calulateBookingTimes(
        vm.schedule, vm.service, vm.layouts,
        vm.booking.duration, vm.booking.people, vm.tables, bookingsByTable,
        vm.booking.preferredSectionId, null, true,
        null, true
      );

      // make sure the set booking time has been checked, this is maily for walkin whick can be booked at any time
      // move to isBookingTimeInList function in booking-availability-service of submodule
     var isInList = BookingAvailabilityService.isBookingTimeInList(bookingTimes, vm.booking.time);

      if (!isInList) {
        // if the booked time is not in the list check if it is available
        var bookedTime = BookingAvailabilityService.checkBookingsAtTime(
          vm.booking.time,
          vm.bookingDate,
          vm.schedule,
          vm.service,
          vm.layouts,
          vm.booking.duration,
          vm.booking.people,
          vm.tables,
          bookingsByTable,
          vm.booking.preferredSectionId,
          null,
          true
        );
        bookingTimes.push(bookedTime);
      }

      vm.bookingTimes = bookingTimes;

      // move to getSelectedBookingTimeFromList function in booking-availability-service of submodule
      const selectedBookingTimeFromList = BookingAvailabilityService.getSelectedBookingTimeFromList(vm.bookingTimes, vm.booking.time);
      vm.selectedTimeId = selectedBookingTimeFromList.selectedTimeId;
      vm.selectedTime = selectedBookingTimeFromList.selectedTime;

      createTableSectionList();
    }

    if (!vm.setUp) {
      t1 = performance.now();
      TelemetryService.track('editBookingSetUp', [
        ['duration', t1 - t0]
      ]);
    }
    vm.setUp = true;
    getChanges();
  }


  function changeTimeToNow() {
    var date = DateUtilsService.getVenueTime(timezoneId);
    date.setSeconds(0);
    date.setMilliseconds(0);
    vm.booking.time = date;
    bookingTimeChange();
    bookingReactRerender();
  }

  function resetTime() {
    vm.booking.time = vm.orgBookingTime;
    bookingTimeChange();
    bookingReactRerender();
  }

  function bookingTimeChange() {
    vm.bookForDate = ObjectCopyService.angularSafeCopy(vm.booking.time);
    vm.service = null;
    vm.selectdTableIds = [];
    getSchedule();
  }

  function createTableSectionList() {
    if (vm.selectedTime && vm.sectionsLookup) {
      const {
        tableSelectionList,
        tableSelectionListWithJoins,
        tableStatusLookUps
      } = TableSelectionService.createTableSectionList(vm.selectedTime, vm.tables, vm.sectionsLookup);

      tableLookUps = tableStatusLookUps;
      vm.selectFromTables = tableSelectionList;
      vm.selectFromTablesOptions = tableSelectionListWithJoins;
      checkTablesSelection();
      updateTables();
    } else {
      tableLookUps = {};
    }
  }

  /**
   * Note: I think this function is redundant, as `selectedTableStatus` doesn't seem to be used anywhere
   */
  function checkTablesSelection() {
    vm.selectedTableStatus = 'avaiable'; // used for css class name
    let allAvailable = true;
    let totalCapacity = 0;
    let minCapacity = 0;

    vm.selectdTableIds.some(tableId => {
      const tableLookUp = tableLookUps[tableId];
      if (tableLookUp) {
        const table = tableLookUp.table;
        totalCapacity += table.capacity;
        if (table.minCapacity > minCapacity) {
          minCapacity = table.minCapacity;
        }
        if (!tableLookUps[tableId].free) {
          allAvailable = false;
          vm.selectedTableStatus = 'unavaiable'; // used for css class name
          return true;
        }
      }
      return false;
    });

    if (allAvailable) {
      if (vm.booking.people > totalCapacity || vm.booking.people < minCapacity) {
        vm.selectedTableStatus = 'unavaiable'; // used for css class name
      }
    }
  }

  /**
   * A new time has been selected
   */
  function timeChange(value, oldValue) {
    if (vm.bookingTimes && oldValue !== null && Number(value) !== Number(oldValue)) {
      vm.selectedTime = vm.bookingTimes[vm.selectedTimeId];

      selectTable();
      createTableSectionList();
    }
  }

  function selectTable() {
    var availableTime = vm.selectedTime;
    vm.booking.time = availableTime.time;
    MenuOptionReducerService.setBookingTime(vm.booking.time);
  }

  function getSectionIdsList(tables) {
    var sectionLookUp = {};
    var sectionIds = [];
    for (var i = tables.length - 1; i >= 0; i--) {
      var table = tables[i];
      if (!sectionLookUp[table.sectionId]) {
        sectionLookUp[table.sectionId] = table.sectionId;
        if (table.sectionId) {
          sectionIds.push(table.sectionId);
        }
      }
    }
    return sectionIds;
  }

  function getCustomer() {
    if (vm.booking.customerId) {
      return CustomerLookupService.getById(vm.booking.customerId).then(customer => {
        setCustomer(customer);
      }).catch(error => {
        console.error('Edit Booking: Get Customer', vm.booking.customerId, error);
        setCustomer(null);
      });
    } else {
      return Promise.resolve().then(() => setCustomer(null));
    }
  }

  function setCustomer(customer) {
    var setCustomerPromise = Promise.resolve();
    vm.customerLoaded = true;
    if (customer) {
      vm.customer = customer;
      orgCustomer = ObjectCopyService.angularSafeCopy(customer);
      vm.customerLabel = CustomerGeneratorService.getDisplayName(vm.customer, true);
      checkSMSAllowed(vm.customer.phone);
      return setCustomerPromise
        .then(() => getCustomerHistory())
        .then(() => getVenueVisitHistory())
        .then(() => updateBookingCustomerInfo(true));
    } else {
      vm.customerLabel = CustomerGeneratorService.getDisplayName(vm.booking, true);
      checkSMSAllowed(vm.booking.phone);
      return setCustomerPromise;
    }
  }

  function updateBookingCustomerInfo(dontUpdateInPouch) {
    let orgBookingWithCustomer;
    if (vm.customer) {
      orgBookingWithCustomer = cloneDeep(orgBooking);

      //// update customer fields in booking  NOTE: DRAVE REMOVED THIS < SHOULD BE FIXED BY DECEMBER 1st 2020
      //CustomerNormaliseService.updateBookingCustomerInfo(vm.booking, vm.customer);
      //CustomerNormaliseService.updateBookingCustomerInfo(orgBookingWithCustomer, vm.customer);
      //// add missing tags that are in customer object but not in booking
      //bookingsService.updateBookingPermanentTags(vm.booking, vm.customer);
      //bookingsService.updateBookingPermanentTags(orgBookingWithCustomer, vm.customer);
    }

    // update original booking with customer details
    if (!dontUpdateInPouch) {
      BookingUpdateService.updateFromAnywhere(orgBookingWithCustomer, orgBooking).then((booking) => {
        orgBooking = booking;
        BookingsUtilsService.setEditBookingOriginal(orgBooking);
      }).catch(err => {
        console.error('EditBooking.Update error', err);
        vm.state = err.name === 'conflict' ? vm.ERROR_CONFLICT : vm.ERROR;
      });
    }
  }

  function checkSMSAllowed(phone) {
    var venue = AdminService.getVenue();
    if (phone && venue.enableSmsWaitList && vm.isDateToday) {
      vm.allowSMS = true;
    }
  }

  function cancel() {
    BookingsUtilsService.setEditBookingOriginal(null);
    closeDialog();
  }

  function preUpdateCheckPayment() {
    // check payment
    if (!vm.booking.paymentSummary && vm.booking.paymentDetails && vm.paymentForm
      && vm.booking.paymentDetails.paymentType !== PaymentTypes.NoPayment && !vm.paymentForm.$valid
    ) {
      vm.paymentForm.$setSubmitted(true);
      vm.selectedTab = TabSelectionService.getEditBookingVisibleTabIndex(EditBookingTabs.paymentDetails);
      // show price validation message
      if (!vm.displayErrors) {
        vm.displayErrors = true;
      }
      return false;
    } else if (!PaymentValidationService.isPaymentPhoneValid || !PaymentValidationService.isPaymentEmailValid || !PaymentValidationService.isBookedByPaymentPhoneValid || !PaymentValidationService.isBookedByPaymentEmailValid) {
      vm.selectedTab = TabSelectionService.getEditBookingVisibleTabIndex(EditBookingTabs.paymentDetails);
      return false;
    }
    return true;
  }

  function preUpdateCheckStaff(waitList = false) {
    vm.staffEditRequired = staffEditRequiredFromSettings && !StaffService.staffNameNotRequired({
        oldBooking: vm.oldBooking, newBooking: vm.booking, staffEnabled: vm.staffEditEnabled, waitList,
      staffEditOptions, orgCustomer, updatedCustomer: vm.customer}
    );// To make sure Staff name is not mandatory if the status has been changed to seated


    // check staff name
    if (vm.staffEditRequired && vm.staffEditEnabled && !vm.staffName) {
      vm.bookingDetails.staffName.$setTouched();

      // scroll to bottom of pop up
      var containerElement = getContentDOM();
      containerElement.scrollTop = containerElement.scrollHeight;
      return false;
    }
    return true;
  }

  function preUpdateCheckCovidGuestList() {

    if (vm.venue.isCovidGuestMode && !vm.guestListValid) {
      vm.forceGuestListValidation = true;
      vm.selectedTab = TabSelectionService.getEditBookingVisibleTabIndex(EditBookingTabs.covidGuestList);
      return false;
    }
    return true;
  }

  // @todo: add this to StatusService and write some tests. severity: medium
  function preUpdateSetStatus(newStatusName) {
    const orgPaymentDetails = PaymentService.getPaymentDetailsByBooking(orgBooking);
    const orgBookingIsFree = !orgPaymentDetails || orgPaymentDetails.paymentType === PaymentTypes.NoPayment;
    const newBookingHasPayment = vm.booking?.paymentDetails?.paymentType !== PaymentTypes.NoPayment;
    if (!newStatusName && orgBookingIsFree && newBookingHasPayment) {
      // they just added a payment set the status to payment pending
      newStatusName = BookingStatusNames.PendingPayment;
    }

    var i, status;
    if (newStatusName) {
      const {fullStatusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
      // the booking a been seated change its status if this restuarnt has seated status.
      for (i = fullStatusOptions.length - 1; i >= 0; i--) {
        status = fullStatusOptions[i];

        if (status.enabled) {
          if (newStatusName && status.name === newStatusName) {
            vm.booking.status = status;
            break;
          } else if (newStatusName === BookingStatusNames.Seated && status.name === 'Seated') {
            // TODO change this to _id == status_seated
            vm.booking.status = status;
            break;
          }
        }
      }
    } else {
      const {statusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
      // set the status
      for (i = statusOptions.length - 1; i >= 0; i--) {
        status = statusOptions[i];
        if (status.name === vm.statusName && status.enabled) {
          vm.booking.status = status;
          break;
        }
      }
    }

    // check to see if the status was changed
    if (!CompareObjectsService.hasIdenticalData(orgBooking.status, vm.booking.status)) {
      vm.booking = BookingUpdateService.updateAfterStatusChange(vm.booking, orgBooking);
    }
  }

  function setNonStandbyBookingType() {
    if (vm.booking.tables?.length && vm.booking.bookingType !== BookingType.StandbyList) {
      vm.booking.bookingType = BookingType.Booking;
    } else if (vm.booking.bookingType === BookingType.Booking) {
      // if is a booking, but table was removed, converts to waitList
      vm.booking.bookingType = BookingType.WaitList;
    }
  }

  /**
   * Prepares vm.booking object for saving. Also gets used when "Seat & Send Confirmation" is used on standby bookings,
   * because they get saved on the back end and then wait for the update.
   * Returns false if validation fails
   */
  function preUpdate(newStatusName, waitList = false) {
    const paymentSuccess = preUpdateCheckPayment();
    if (!paymentSuccess) {
      return false;
    }

    const staffSuccess = preUpdateCheckStaff(waitList);
    if (!staffSuccess) {
      return false;
    }
    const bookedBySuccess = preUpdateCheckBookedBy();
    if (!bookedBySuccess) {
      return false;
    }

    vm.booking.bookingLinks = vm.bookingLinks; // adding links information to the booking object before saving.

    const covidGuestListSuccess = preUpdateCheckCovidGuestList();
    if (!covidGuestListSuccess) {
      return false;
    }

    // "Function Tracker" service option is always selected for the function tracker booking, so don't save the service.
    if (!vm.booking.functionTracker) {
      vm.booking.serviceId = vm.service._id;
    }

    preUpdateSetStatus(newStatusName);
    setNonStandbyBookingType();

    return true;
  }

  function update(newStatusName, waitList = false, closeDialogOnSuccess = true) {
    NetworkConnectionService.checkCouchDbIsReachable();

    const preUpdateSuccess = preUpdate(newStatusName, waitList);
    if (!preUpdateSuccess) {
      return Promise.resolve(false);
    }
    if (!vm.isPaymentLinkPopupConfirmed && vm.booking.paymentDetails?.paymentType !== PaymentTypes.NoPayment
      && (PaymentValidationService.isPaymentPhoneUpdateChecked || PaymentValidationService.isPaymentEmailUpdateChecked)
    ) {
      showUpdatePaymentLinkInfoConfirmationDialog();
      return Promise.resolve(false);
    }
    return $q(resolve => {

      vm.state = vm.LOADING;
      var t2 = performance.now();

      // triggers refresh
      bookingReactRerender();

      // const booking = cloneDeep(vm.booking);
      var booking = cloneDeep(vm.booking);
      booking = PhoneNumberService.resetPhoneNumberWithTypeValidation(booking); // Remove country prefix when national number contains special char and a~z A~Z
      var tempCustomer = cloneDeep(vm.customer);
      if (PaymentValidationService.isPaymentEmailUpdateChecked) {
        tempCustomer.email = PaymentValidationService.paymentEmail;
      }
      if (PaymentValidationService.isPaymentPhoneUpdateChecked) {
        tempCustomer.phone = PaymentValidationService.paymentPhone;
      }
      if(PaymentValidationService.isBookedByPaymentEmailUpdateChecked) {
        booking.bookedBy.email = PaymentValidationService.bookedByPaymentEmail;
      }
      if(PaymentValidationService.isBookedByPaymentPhoneUpdateChecked) {
        booking.bookedBy.phone = PaymentValidationService.bookedByPaymentPhone;
      }
      tempCustomer = PhoneNumberService.resetPhoneNumberWithTypeValidation(tempCustomer); // Remove country prefix when national number contains special char and a~z A~Z
      if (PaymentValidationService.isPaymentEmailUpdateChecked || PaymentValidationService.isPaymentPhoneUpdateChecked) {
        CustomerUpdateService.update(tempCustomer);
      }

      BookingNormaliseService.removeTablesStandbyBookingType(booking);

      // using the first selectedTableId because if using the layout-based table join, which is prefixed with 'join_', there can only be one selected.
      const firstSelectedTable = booking.tables[0];
      if (firstSelectedTable && firstSelectedTable._id.indexOf(JOIN_PREFIX) === 0) {
        const isManualJoin = false;
        // back end has no notion of a table join object, so must convert it to multiple tables before saving
        booking.tables = TableJoinService.convertToManualJoin([firstSelectedTable._id], booking.tables, isManualJoin);
      }
      //check whether need force update customer
      const forceUpdateCustomer = !CompareObjectsService.hasIdenticalData(vm.customer, orgCustomer);
      BookingUpdateService.updateFromEditBookingSave(booking, orgBooking, tempCustomer, orgCustomer, vm.sendConfirmation, vm.sendSMSConfirmation, vm.staffName, vm.schedule, null, false, forceUpdateCustomer).then(() => {
        const origBookingHasNoPayment = PaymentService.getBookingHasNoPayment(orgBooking, true);

        const {status, bookingType, paymentDetails} = vm.booking;
        const isSBPaymentWithoutTable = status.statusType === BookingStatusTypes.PendingPayment && bookingType === BookingType.StandbyList;
        const newBookingHasPayment = paymentDetails && paymentDetails.paymentType !== PaymentTypes.NoPayment;

        // only show the payment popup if the new booking has a payment that wasn't there before and it is not a Standby Payment without a table (in payment-pending)
        if (origBookingHasNoPayment && newBookingHasPayment && !isSBPaymentWithoutTable && vm.statusName !== BookingStatusNames.Cancelled) {
          generateBookingUrl();
          vm.state = vm.SHOW_PAYMENT_URL;

          orgBooking = cloneDeep(booking);
          BookingsUtilsService.setEditBookingOriginal(orgBooking);
        } else {
          if (closeDialogOnSuccess) {
            vm.state = vm.SUCCESS;
            $timeout(() => {
              closeDialog();
              BookingsUtilsService.setEditBookingOriginal(null);
            }, 300);
          } else {
            vm.state = vm.ENTER;
          }
        }


        $rootScope.$broadcast('booking-edited', vm.booking);

        TelemetryService.track('updateBooking', [
          ['duration', performance.now() - t2]
        ]);

        resolve(true);
      }).catch(err => {
        console.log('EditBooking.Update error', err);
        vm.state = err.name === 'conflict' ? vm.ERROR_CONFLICT : vm.ERROR;
      });
    });
  }


  function querySearch(query) {
    if (!query) {
      return vm.customers;
    }

    var q = query.toLowerCase();
    return vm.customers.filter(function (customer) {
      if (customer.lastName.toLowerCase().indexOf(q) === 0) {
        return true;
      }
      if (customer.phone.toLowerCase().indexOf(q) === 0) {
        return true;
      }
      if (customer.email.toLowerCase().indexOf(q) === 0) {
        return true;
      }
      return false;
    });
  }

  function generateBookingUrl() {
    vm.paymentUrl = '';
    if (vm.booking.paymentDetails && vm.booking.paymentDetails.paymentType !== PaymentTypes.NoPayment && (!vm.booking.paymentSummary || !vm.booking.paymentSummary.transactionId)) {
      vm.paymentUrl = UrlGeneratorService.generateBookingUrl(vm.booking._id);
    }
  }

  function managePreAuth(evt) {
    AppEventService.emit('managePreAuth', vm.booking, evt);
  }

  function onSendSMSConfirmationUpdate(sendConfirmation) {
    vm.sendSMSConfirmation = sendConfirmation;
  }

  function onSendConfirmationUpdate(sendConfirmation) {
    vm.sendConfirmation = sendConfirmation;
  }

  function onStandbyReset() {
    vm.selectdTableIds = [];
    const {isSBPaymentPending, isSBPaymentUnconfirmed} = StatusService.getStandbyPaymentPendingState(vm.booking.status.statusType, vm.booking.paymentDetails, vm.booking.bookingType);

    const hasPaidMoney = booking.paymentSummary && booking.paymentSummary.amountPaid > 0;
    if (!hasPaidMoney && (isSBPaymentPending || isSBPaymentUnconfirmed)) {
      vm.statusName = StatusServiceInstance.updateBookingStatusWithPaymentPendingUnconfirmed(vm.booking);
    } else {
      vm.booking.status = StatusUnconfirmed;
      vm.statusName = BookingStatusNames.Unconfirmed;
    }

    updateStatusList();
  }

  function onStandbyUpdate(doUpdate, savedBooking, isBlocked, statusNameForOfflineMode) {

    if (isBlocked) {
      vm.bookingDetails.staffName.$setTouched();
      return false;
    }

    if (statusNameForOfflineMode) {
      update(statusNameForOfflineMode)
        .then(() => closeDialog());
      return true;
    }

    if (doUpdate) {
      const success = preUpdate(); // needs to run preUpdate checks so the booking object gets latest updates
      if (!success) return false; // if validation fails, stop loading

      vm.state = vm.LOADING;
    } else if (savedBooking) { // updates back end and waits for couch to refresh
      /**
       * This will have saved the booking on the back end, so we don't need (and don't want) to save it again, as
       * `StandByConfirmationExpiry` would get overridden.
       */
      closeDialog();
    } else {
      vm.state = vm.ENTER;
    }
    return true;
  }

  function handleTableIdsChange(selectedTableIds, tableList, isManualJoin) {

    vm.booking.tables = tableList.filter(({_id}) => selectedTableIds.includes(_id));

    /**
     * StandbyTableSeater uses a different property 'sblSelectedTableIds' to the normal tableSeater because of looping
     * render/digest issues. NBI-5641
     */
    if (vm.booking.bookingType === BookingType.StandbyList) {
      vm.sblSelectedTableIds = selectedTableIds;
    } else {
      vm.selectdTableIds = selectedTableIds;
    }

    vm.selectFromTablesOptions = tableList;
    bookingReactRerender();
    if (vm.booking.tables?.length > 0 && settings.enableMaxOccupancy) {
      let sectionMaxOccupancy = '';

      vm.isMultipleSection = BookingIntervalService.checkIfBookingOverMultipleSections(vm.booking);
      if (vm.isMultipleSection) {
        let isOverMax = '';
        vm.sections.forEach((section) => {
          if (section._id !== SECTION_ANY_ID && isOverMax !== OVER_MAX) {
            isOverMax = MaxOccupancyService.checkForCovidMaxOccupancy(vm.booking, vm.coversBookingIntervals, [section], vm.isMultipleSection);
          }
          sectionMaxOccupancy = isOverMax;
        })
      } else {
        sectionMaxOccupancy = MaxOccupancyService.checkForCovidMaxOccupancy(vm.booking, vm.coversBookingIntervals, vm.sections, vm.isMultipleSection);
      }
      vm.showMaxOccupancyMessage = sectionMaxOccupancy === OVER_MAX;
    }
  }

  function handleCustomerDetailsUpdate(firstName, phone) {
    vm.booking.firstName = firstName;
    vm.booking.phone = phone;
    bookingReactRerender();
  }

  function setPhoneWithoutPrefix(phone) {
    vm.phoneWithoutPrefix = phone;
  }

  function onServiceSelected(selectedId) {
    vm.serviceId = selectedId;
  }

  /**
   * If time has been picked from list, `selectedIndex` will be more than -1 and `time` will be null,
   * but if it is a custom time the `time` will be populated.
   */
  function onTimeChanged(selectedIndex, time) {
    if (time) {
      vm.booking.time = DateUtilsService.setTimeFromString(vm.booking.time, time);

      vm.selectedTime = BookingAvailabilityService.checkBookingsAtTime(
        vm.booking.time, vm.bookingDate, vm.schedule, vm.service, vm.layouts, vm.booking.duration,
        vm.booking.people, vm.tables, bookingsByTable, vm.booking.preferredSectionId, null, true);

      selectTable();
      createTableSectionList();
    } else {
      vm.selectedTimeId = selectedIndex;
    }

    bookingReactRerender();
  }


  function handleCancelBooking() {
    update(BookingStatusNames.Cancelled);
  }

  // triggers a react rerender
  function bookingReactRerender() {
    vm.booking = {...vm.booking};
  }

  function showBookingOptions(isUpsell = false) {
    return MenuOptionsService.showManageBookingOptions(
      isUpsell, vm.booking.method, vm.venue.isTakeAwayMode, vm.booking.people,
      vm.activePaymentDetails, vm.originalPaymentDetails,
      vm.menuBookingOptions, vm.menuUpsellOptions);
  }

  function setBookingOptions() {
    vm.menuBookingOptions = vm.activePaymentDetails && vm.activePaymentDetails.menuOptions ? MenuOptionsService.getMenuOptionDetailsFromIds(vm.activePaymentDetails.menuOptions, vm.allBookingOptions) : [];

    // if there are selected BO or UO and we try to change pax which changes the existing BO or UO - Disable save and throw error - https://nowbookit.atlassian.net/browse/NBI-3906
    const boChanged = MenuOptionsService.checkIfOptionsChanged(vm.activePaymentDetails?.menuOptions, vm.originalBOIds);
    const uoChanged = MenuOptionsService.checkIfOptionsChanged(vm.activePaymentDetails?.menuOptionsUpsell, vm.originalUOIds);
    bookingOptionsValid = vm.selectedBookingOptions.length === 0 || !boChanged;
    upsellOptionsValid = vm.selectedUpsellOptions.length === 0 || !uoChanged;

    if (isPaxChanged && vm.booking.selectedMenuOptions?.length > 0 && (boChanged || uoChanged)) {
      vm.disableSaveForPaxThreshold = true;
    } else {
      isPaxChanged = true;
      vm.disableSaveForPaxThreshold = false;
    }

    vm.menuBookingOptions = vm.menuBookingOptions.map((options) => {
      const childIds = MenuOptionsService.getChildBookingOptionsIds(options);
      if (!isEmpty(childIds)) {
        const childMenuOptions = MenuOptionsService.getMenuOptionDetailsFromIds(childIds, vm.allBookingOptions);
        options = {...options, childOptions: childMenuOptions};
      }
      return options;
    });

    const upsellOpts = vm.activePaymentDetails && vm.activePaymentDetails.menuOptionsUpsell;
    vm.menuUpsellOptions = upsellOpts ? MenuOptionsService.getMenuOptionDetailsFromIds(upsellOpts, vm.allBookingOptions) : [];
  }

  function showMenuOptionsClear() {
    // Shw the clear all button when there is change in pax and BO are in conflict.
    return vm.booking.status.name === BookingStatusNames.Unconfirmed && vm.disableSaveForPaxThreshold;
  }

  function removeBO() {
    vm.selectedBookingOptions = [];
    vm.booking = MenuOptionsService.filterBasedOnUpsellItem(vm.booking, true);
    bookingOptionsValid = true;
    vm.disableSaveForPaxThreshold = !upsellOptionsValid;
    updatePaymentBasedOnBookingOptions(vm.booking.selectedMenuOptions);
  }

  function removeUO() {
    vm.selectedUpsellOptions = [];
    vm.booking = MenuOptionsService.filterBasedOnUpsellItem(vm.booking, false);
    upsellOptionsValid = true;
    vm.disableSaveForPaxThreshold = !bookingOptionsValid;
    updatePaymentBasedOnBookingOptions(vm.booking.selectedMenuOptions);
  }

  /**
   * Allows customer bookings list to get really long, which affects performance, and is off by default.
   */
  function showAllCustomerBookings() {
    vm.customerBookingsLimit = 10000;
  }


  /**
   * Toggles bookingType between StandbyList & Booking
   */
  function handleStandbyBtn() {
    vm.sectionMessage = '';

    const wasStandby = vm.booking.bookingType === BookingType.StandbyList;
    vm.booking.bookingType = wasStandby ? BookingType.Booking : BookingType.StandbyList;

    const isStandby = !wasStandby;
    if (isStandby) {
      vm.booking.tables = [];
      onStandbyReset();
      setStandbyPendingPayment();
    }
    // triggers refresh
    bookingReactRerender();
  }

  function disablePaymentType() {
    return TabSelectionService.doShowEditBookingTab(EditBookingTabs.bookingOptions)
      && vm.booking.paymentDetails
      && vm.booking.paymentDetails.paymentType !== PaymentTypes.NoPayment;
  }

  function getAllTags() {
    TagsService.getTags().then(function (tags) {
      vm.allTags = tags;
    });
  }

  function updateBookingLink(bookingLinks) {
    vm.bookingLinks = [...bookingLinks];
    vm.validBookingLinks = BookingValidationService.determineValidBookingLinks(vm.bookingLinks);
  }

  function addBookingLink() {
    const bookingLinks = BookingsUtilsService.addBookingLink(cloneDeep(vm.bookingLinks));
    updateBookingLink(bookingLinks) // to render react component
  }

  function handleSendLinkPaymentResponseAndCloseOnSuccess(errName) {

    if (errName) {
      console.warn('SendLinkPayment error', err);
      vm.state = errName === 'conflict' ? vm.ERROR_CONFLICT : vm.ERROR;
    }

    if (!errName) {
      // timeout just so we can see the success message briefly
      setTimeout(() => closeDialog(), 1500);
    }
  }


  /**
   * Checks that DOM matches the TabSelectionService -> editBookingTabs list
   */
  function verifyTabOrder() {
    const containerElement = getContentDOM();
    const tabs = containerElement.querySelectorAll('md-tab');
    const tabVisibilityList = TabSelectionService.getEditBookingVisibleTabs();
    if (tabVisibilityList.length !== tabs.length) {
      console.warn(NS, 'verifyTabOrder', `"tabVisibilityList" length ${tabVisibilityList.length} doesn't equal "tabs" length ${tabs.length}.`);

      Array.from(tabs).forEach((tab, i) => {
        const label = containerElement.querySelectorAll('md-pagination-wrapper md-tab-item')[i];

        if (tabVisibilityList[i] && label && label.textContent && label.textContent.trim().includes(tabVisibilityList[i].title)) {
          console.warn(NS, `tab order doesn't match 'tabVisibilityList'`, label, tabVisibilityList[i]);
        }
      });
    }

  }

  function getContentDOM() {
    return angular.element($document[0].querySelector('#editBookingContent'))[0];
  }

  /**
   * Saves the booking but doesn't close the dialog.
   * Useful for things like opening a payment page that could potentially change the status of the booking, which
   * would cause a conflict with the open booking and you'd lose your changes. At least this way you only get a conflict
   * on changes made after
   */
  function updateWithoutClosing() {
    const preUpdateSuccess = preUpdate(); // needs to check validation before going ahead with the save
    if (!preUpdateSuccess) {
      return Promise.resolve({success: false, reason: 'Validation Failed'});
    }

    return new Promise(resolve => {
      update(null, false, false)
        .then(success => {
          if (success) {
            resolve({success});
          } else {
            resolve({success, reason: 'Save Failed'});
          }
        });
    });
  }

  async function getCustomerAmountDetails() {
    const average = await ReportingService.getCustomerAmountDetails(vm.venue.id, vm.booking.customerId);
    vm.avgSpendAmount = IntlService.currencyValueAsString(average, vm.venue.currency);
  }

  function getBookingChangesByApiCssStyle() {
    // a booking change coming from POS API has method startWith => 'API - [PartnerName]'
    if (vm.booking.method.startsWith('API - '))
      return " api";

    if(vm.booking.recurringBookingId)
      return " recurring"

    // otherwise, return just the booking method as css (phone, walkin, email, etc. )
    return vm.booking.method;
  }

  function openRecurringBooking(booking) {
    $rootScope.$broadcast('edit-booking', null, booking);
  }

  function handleCancelRecurringBookings(recurringBookings) {
    vm.recurringBookings = recurringBookings;
  }

  function calculateNumberOfRecurringBookings() {
    const recurringBookings = vm.recurringBookings?.filter(b => b.status.statusType !== BookingStatusTypes.Cancelled)
    return recurringBookings?.length > 0 ? recurringBookings.length : ''
  }

  function handleEmailSmsNotification(stopNotification) {
    vm.booking.disableEmailSmsNotification = stopNotification;
    bookingReactRerender();
  }

  function setBookedByCustomerDetails(key, value) {
    const resendingFields = ['notifySms', 'notifyEmail'];
    if (resendingFields.includes(key)) {
      vm.booking.bookedByNotify[key] = value;
    } else {
      vm.booking.bookedBy[key] = value;
    }
  }
  function setBookedByErrors(errors) {
    if (Object.values(errors||{}).filter(item => !!item).length > 0 || isBookedByEmpty()) {
      vm.isBookedByValid = false;
    } else {
      vm.isBookedByValid = true;
    }
    vm.bookedByErrors = errors;
    isSaveEnable();
  }
  function isBookedByEmpty() {
    if (!vm.booking.isBookedBy || !vm.booking.bookedBy) {
      return true;
    }
    return !((vm.booking.bookedBy.firstName || vm.booking.bookedBy.lastName) && (vm.booking.bookedBy.email || vm.booking.bookedBy.phone));
  }
  function preUpdateCheckBookedBy() {
    if (vm.booking.isBookedBy && Object.values(vm.bookedByErrors  || {}).filter(item => !!item).length > 0
    && isBookedByEmpty()
    ) {
      vm.selectedTab = TabSelectionService.getEditBookingVisibleTabIndex(EditBookingTabs.bookedBy);
      vm.triggerBookedByValidation += 1;
      return false;
    }
    return true;
  }

  function toggleBookedByWithEditBooking(checked) {
    if (checked) {
      // initial bookedBy in case undefined error
      vm.booking.bookedBy = {};
    }
    vm.booking.isBookedBy = checked;
    isSaveEnable();
    vm.triggerBookedByValidation = 1;
  }

}
